import { FC } from "react";

import { Customer } from "~/application/types";
import { Divider } from "~/components/Divider";
import { Flex } from "~/components/Flex";
import { Icon } from "~/components/Icon";
import { SvgArrowBack } from "~/components/Icon/icons";
import { TextInput } from "~/components/Input";
import { Text } from "~/components/Text";
import { useUser } from "~/presentation/core/contexts/UserContext";
import { ListItem } from "~/presentation/shared/components/ListItem";
import { useQueryCustomers } from "~/presentation/shared/hooks/useQueryCustomers";
import { asCNPJ } from "~/utils/mask.utils";

type SidebarCustomerListProps = {
  setCustomerContext: (customer: Customer) => void;
  onCloseClick?: () => void;
};

export const SidebarCustomerList: FC<SidebarCustomerListProps> = ({
  setCustomerContext,
  onCloseClick,
}) => {
  const { contexts } = useUser();

  const { customers, isFetchingCustomers, searchText, setSearchText } = useQueryCustomers({
    options: { enabled: !!contexts.agency },
  });

  return (
    <Flex
      css={{
        width: "100%",
        height: "100%",
        backgroundColor: "white",
        borderRadius: "$md",
        p: "$4",
      }}
      direction="column"
      gap="4"
    >
      <Flex direction="column" gap="4">
        <Flex align="center" gap="4">
          <Icon as={SvgArrowBack} onClick={onCloseClick} variant="primary" size="lg" />
          <Text variant="primary" size="5">
            Empresas
          </Text>
        </Flex>
        <TextInput
          placeholder="Digite o nome da empresa"
          value={searchText}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSearchText(e.target.value)}
        />
      </Flex>
      <Divider
        css={{
          my: "$4",
          borderColor: "$neutrals-light",
        }}
      />
      <Flex
        direction="column"
        gap="4"
        css={{
          overflowY: "auto",
        }}
      >
        {isFetchingCustomers
          ? Array.from({ length: 10 }).map((_, index) => (
              <ListItem
                onClick={() => {}}
                title={`Carregando ${index + 1}`}
                description={`Carregando ${index + 1}`}
                isLoading={isFetchingCustomers}
                key={index}
              />
            ))
          : customers?.data.map((customer) => (
              <ListItem
                title={customer.companyName}
                description={asCNPJ(customer.cnpj)}
                onClick={() => setCustomerContext(customer)}
                isLoading={isFetchingCustomers}
                isSelected={contexts.customer?.uuid === customer.uuid}
                key={customer.uuid}
              />
            ))}
      </Flex>
    </Flex>
  );
};
